import { AIRLINES } from "src/common/constants";
import { AirlineCodes, AirlinesAction } from "../reducers/airlines";
export const AIRLINES_FETCH_DATA = `${AIRLINES}_GET_DATA` as const;
export const AIRLINES_FETCH_SUCCESS = `${AIRLINES}_GET_SUCCESS` as const;
export const AIRLINES_FETCH_FAILED = `${AIRLINES}_GET_FAILED` as const;

export const fetchAirlines = (): AirlinesAction => ({
  type: AIRLINES_FETCH_DATA,
});
export const fetchAirlinesSuccess = (payload: {
  airlineCodes: AirlineCodes;
}): AirlinesAction => {
  return {
    type: AIRLINES_FETCH_SUCCESS,
    payload,
  };
};
export const fetchAirlinesFailed = ({
  error,
}: {
  error: Error;
}): AirlinesAction => ({
  type: AIRLINES_FETCH_FAILED,
  error,
});
